import PrimitiveAction from "../common/PrimitiveAction.jsx";
import { siteContent } from "../../data/siteContent.js";
import materialTexture from "../../assets/generated/material-texture.webp";

export function JournalSection({ full = false }) {
  return (
    <section className="section journal-section">
      <div className="section-intro">
        <p className="eyebrow">Journal</p>
        <h2>Field notes from the first hardware run.</h2>
        {full ? (
          <p>
            Short notes from the shop, the park, and the drop list keep the first run grounded
            in boards, obstacles, and rider feedback.
          </p>
        ) : null}
      </div>
      <div className="journal-grid">
        {siteContent.journal.map((item) => (
          <article className="journal-card" key={item.title}>
            <div className="journal-meta">
              <span>{item.meta}</span>
              <time>{item.date}</time>
            </div>
            <h3>{item.title}</h3>
            <p>{item.copy}</p>
            {full ? <p className="journal-body">{item.body}</p> : null}
          </article>
        ))}
        {full ? (
          <article className="journal-card journal-feature">
            <p className="eyebrow">Field Note</p>
            <h3>Drop 01 Field Notes</h3>
            <p>
              Drop 01 is shaped around a tight hardware language: compact boards, controlled
              concave, and a restrained finish system that makes every piece feel deliberate.
            </p>
            <p className="journal-body">
              Expect short recaps from test sessions, rider spotlights, setup photos, and notes
              on how the boards and obstacles wear in after real table time.
            </p>
          </article>
        ) : null}
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section className="contact-section">
      <img className="contact-texture" src={materialTexture} alt="" aria-hidden="true" draggable="false" />
      <div>
        <p className="eyebrow">Contact</p>
        <h2>{siteContent.contact.heading}</h2>
        <p>{siteContent.contact.copy}</p>
        <div className="contact-signals" aria-label="Contact routing">
          {siteContent.contact.signals.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
        <p className="commerce-note">First-run purchasing opens when Drop 01 is announced.</p>
      </div>
      <PrimitiveAction href={`mailto:${siteContent.contact.email}?subject=Magdump%20launch%20interest`} variant="primary">
        {siteContent.brand.primaryAction}
      </PrimitiveAction>
    </section>
  );
}
